/**
 * Level-Up Gamification Configuration
 *
 * 5-level learning ladder. The reward is the milestone itself: the quiz-level
 * subscription discount was retired (owner, 2026-09-18; built 2026-10-02) —
 * campaign promotion codes are the only discount path.
 */

/** Series title for the certification program */
export const CERTIFICATION_TITLE = 'IA Certification';

export const LEVEL_CONFIG = [
  { level: 0, name: 'Candidate' },
  { level: 1, name: 'Level I' },
  { level: 2, name: 'Level II' },
  { level: 3, name: 'Level III' },
  { level: 4, name: 'Level IV' },
  { level: 5, name: 'Level V' },
] as const;

export type LevelName = (typeof LEVEL_CONFIG)[number]['name'];

export const QUIZ_PASSING_SCORE = 70; // percentage

export const MAX_LEVEL = 5;
